module.exports = __webpack_public_path__ + "static/media/connection_service_business_unit_2.057b7c71.png";